<template>

    <div class="alert alert-danger" v-if="error_message !== null">
        <p>{{ error_message }}</p>
    </div>

    <form @submit.prevent="showConfirmationDialog">
        <button type="submit" class="btn btn-primary">Subscribe now</button>
    </form>

    <!-- Confirmation Modal -->
    <div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationModalLabel">Confirm Subscription</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    Are you sure you want to subscribe?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" @click="create" data-bs-dismiss="modal" >Confirm</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useToast} from "vue-toastification";
import AppLayout from "../../app-layout.vue";

const toast = useToast();

export default {
    props: ['course','price'],
    components: {
        AppLayout
    },
    data() {
        return {
            form_options: {},
            item: {},
            validationErrors: null,
            error_message: null,
        }
    },
    methods: {
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        showConfirmationDialog() {
            const confirmationModal = new bootstrap.Modal(document.getElementById('confirmationModal'));
            confirmationModal.show();

            var firstDivContent = document.getElementById('confirmationModal');
            var secondDivContent = document.getElementById('modal-codes');
            secondDivContent.innerHTML = firstDivContent.innerHTML;
            firstDivContent.remove();
        },
        // close() {
        //     const confirmationModal = new bootstrap.Modal(document.getElementById('confirmationModal'));
        //     confirmationModal.hide();
        // },
        create() {
            const id = toast.info('creating ...', {icon: 'fa-solid fa-cloud-arrow-up'});

            const that = this;
            this.validationErrors = null;
            this.error_message = null;

            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });
            formData.append('course_id', this.course?.id);
            if(this.price !== null){
                formData.append('price_id', this.price?.id );
            }

            axios.post('subscriptions', formData)
                .then(response => {
                    toast.dismiss(id);
                    toast.success(response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-check'});
                    this.item = {};
                    const confirmationModal = new bootstrap.Modal(document.getElementById('confirmationModal'));
                          confirmationModal.hide();
                          document.getElementById('confirmationModal').remove();

                    var secondDivContent = document.getElementById('modal-codes');
                        secondDivContent.innerHTML = '';

                    console.log('confirmationModal removed');
                    // this.close();
                    this.$router.push({name: 'dashboard.home', params: { 'subscribe_id' : response.data?.data?.id }});

                }).catch(function (error) {

                // this.close();
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors;
                    that.error_message = error.response.data.message;
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-exclamation'});
                }
            });
        },
    },
}
</script>
